
export interface MetadataExt extends Metadata{
  joinId?:string,
  order?:number,
  value?:string,
}

export interface MetadataSearchCriteria{
  identifier:string,
  value:string,
}


export interface Metadata {
    id?:string,
    identifier: string,
    name:string,
    description:string,
    type: MetadataType,
    validators : MetadataValidator[],
    suggestion:string,
    options?:MetadataOption[],
    removed:boolean
}

export interface MetadataOption {
  id?:string,
  name: string,
  description: string,
  value:string;
}

export interface MetadataType {
  id: MetadataTypeIdentifier,
  name: string,
  description: string,
  validators : MetadataValidator[],
  hasOptions: boolean
}

export interface MetadataValidator {
  id: MetadataValidatorIdentifier,
  name: string,
  description: string,
  preset?: boolean,
  value: string
}

export enum MetadataTypeIdentifier {
  TEXT_SHORT = 'TEXT_SHORT',
  TEXT_LONG = 'TEXT_LONG',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  URL = 'URL',
  DATE = 'DATE',
  LIST_CHECKBOX = 'LIST_CHECKBOX',
  LIST_RADIOBUTTON = 'LIST_RADIOBUTTON',
  LIST_SINGLE_SELECTION = 'LIST_SINGLE_SELECTION',
  LIST_MULTIPLE_SELECTION = 'LIST_MULTIPLE_SELECTION',
  BINARY_CURSOR = 'BINARY_CURSOR',
  LABEL = 'LABEL'
}

export enum MetadataValidatorIdentifier {
  ALPHABETICAL = 'ALPHABETICAL',
  NUMERIC = 'NUMERIC',
  CURRENCY = 'CURRENCY',
  URL = 'URL',
  PUNCTUATION = 'PUNCTUATION',
  REQUIRED = 'REQUIRED',
  LENGTH = 'LENGTH',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL'
}

export enum ErrorMetadata {
    IDENTIFIER = 'Identificativo già in uso',
    RANGE = 'Intervallo non valido',
    VALIDATORS_VALUES = 'Valori dei validatori non validi',
    BINARY_CURSOR = 'Il cursore binario deve avere due opzioni'
}
